import config from "site-config";
import { fetchJSON } from "lib/fetch";
import { useQuery, QueryConfig } from "react-query";

export const EDIT_PRODUCT = "EDIT_PRODUCT";

interface IResponse {
    brand: string;
    cancelled: boolean;
    description: string;
    color: string;
    name: string;
    _id: string;
    sizes: object[];
}

export const useSizePacksProduct = (sizePacks: string, productId: string, options?: QueryConfig<IResponse>) => {
    return useQuery<any>(
        [EDIT_PRODUCT, productId],
        () =>
            fetchJSON<any>(`${config.api}/api/v3.0/items/packs?_id=${sizePacks}`, {
                method: "GET",
                noDomain: true,
            }).then((responseJson) => responseJson),
        options
    );
};

export const useCancelProduct = (productId: string, options?: QueryConfig<IResponse>) => {
    return useQuery<IResponse>(
        [EDIT_PRODUCT, productId],
        () =>
            fetchJSON<IResponse>(`${config.api}/product/cancel/${productId}`, {
                method: "POST",
                headers: {
                    module: "admin",
                },
                noDomain: true,
            }).then((responseJson) => responseJson),
        options
    );
};

export const useArchiveProduct = (productId: string, options?: QueryConfig<IResponse>) => {
    return useQuery<IResponse>(
        [EDIT_PRODUCT, productId],
        () =>
            fetchJSON<IResponse>(`${config.api}/product/remove/${productId}`, {
                method: "DELETE",
                headers: {
                    module: "admin",
                },
                noDomain: true,
            }).then((responseJson) => responseJson),
        options
    );
};
